import "./Humidification.module.css";
import Header from "@/reusable_sections/Header";
import Humidificacao from "./sections/Humidificacao";
import Humidification from "./sections/Humidification";
import Benefits from "./sections/Benefits";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HumidificationPage() {
  return <div>
      <Header />
      <Humidificacao />
      <Humidification />
      <Benefits />
      <CallToAction />
      <Footer />
    </div>;
}